import { ISmbNode, TSmbExpandedMap } from '../model/types'

import { isSmbNodeExcluded } from './isSmbNodeExcluded'

export interface ISmbRow {
  node: ISmbNode
  depth: number
  ancestors: ISmbNode[]
  canExpand: boolean
  isExpanded: boolean
}

/**
 * The rows currently visible, given each branch's own expand state - every branch expands
 * and collapses independently, so one sub-category can be planned at its own level while
 * another is drilled all the way to L3.
 */
export const buildSmbRows = (root: ISmbNode, expanded: TSmbExpandedMap): ISmbRow[] => {
  const rows: ISmbRow[] = []

  const walk = (node: ISmbNode, depth: number, ancestors: ISmbNode[]) => {
    if (node.isNotApplicable) {
      return
    }

    // A row that is outside the plan never opens into its children
    const canExpand = node.children.length > 0 && !isSmbNodeExcluded(node)
    const isExpanded = canExpand && !!expanded[node.id]

    rows.push({ node, depth, ancestors, canExpand, isExpanded })

    if (isExpanded) {
      node.children.forEach((child) => walk(child, depth + 1, [...ancestors, node]))
    }
  }

  walk(root, 0, [])

  return rows
}
